import React, { useMemo, useState } from 'react';

import { ObjectSchema } from 'yup';
import { useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import {
  CreateAviatorPermissionFormContext,
  CreateAviatorPermissionFormState,
  createAviatorPermissionFormStateDefault,
  createAviatorPermissionSchemaDefault,
} from '@Forms/aviatorPermissions/CreateAviatorPermissionFormContext';

export const CreateAviatorPermissionFormProvider: React.FC<{ children: JSX.Element }> = ({
  children,
}) => {
  const [schema, setSchema] = useState<ObjectSchema<Partial<CreateAviatorPermissionFormState>>>(
    createAviatorPermissionSchemaDefault
  );
  const methods = useForm({
    defaultValues: createAviatorPermissionFormStateDefault,
    resolver: yupResolver(schema),
  });
  const value = useMemo(() => ({ schema, setSchema, methods }), [schema, setSchema, methods]);

  return (
    <CreateAviatorPermissionFormContext.Provider value={value}>
      {children}
    </CreateAviatorPermissionFormContext.Provider>
  );
};
